import { render } from "./Top10.vue?vue&type=template&id=e04d45c2&scoped=true"
import script from "./Top10.vue?vue&type=script&lang=js"
export * from "./Top10.vue?vue&type=script&lang=js"

import "./Top10.vue?vue&type=style&index=0&id=e04d45c2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e04d45c2"

export default script